import formModel from './formModel';
import moment from "moment";

const {
    formField: {
        situacionImpositiva,
        tipoPersona,
        codigosLocalidad,

        vigencia,
        fechaVigencia,
        descuentoModelo,
        frecuenciaPago,
        cuotas,
        ajusteAutomatico,
        equipoTelematica,

        afinidad,
        img_afinidad,
        sumaAsegurada,
        fechaCotizacion,
        zonaRiesgo
    }
} = formModel;

export default {
    motovehiculo: {
        marca: '',
        anio: '',
        version: '',
        valorAdicional: '0',
        usoVehiculo: '2',
        ceroKm: 'false',
    },
    [codigosLocalidad.name]: '',
    [situacionImpositiva.name]: '4',
    [tipoPersona.name]: '0',
    [vigencia.name]: '1',
    [fechaVigencia.name]: '',
    [descuentoModelo.name]: 0,
    [frecuenciaPago.name]: '',
    [cuotas.name]: '',
    [ajusteAutomatico.name]: '',
    [equipoTelematica.name]: '',
    [afinidad.name]: '',
    [img_afinidad.name]: '',


    [sumaAsegurada.name]: 0,
    [fechaCotizacion.name]: moment().format('YYYY-MM-DD'),
    [zonaRiesgo.name]: ""
};
